import React from "react";
import {Footer} from "./Footer";
import {Header} from "./Header";
import "./Layout.scss";
import {MessagePanel} from "../message-panel/message-panel";
import {useAppSelector} from "../../store/hooks";
import {selecteMessages} from "../message-panel/messagesSlice";

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({children}) => {
  const messages = useAppSelector(selecteMessages);

  return (
    <>
      <Header />
      <div id="content">
        <MessagePanel messages={messages} />
        {children}
      </div>
      <Footer />
    </>
  );
};
